import { html } from "lit";

// icons + styles (unchanged)
export const micSlashIcon = (size: number) => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width=${size}
    height=${size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    style="color: white"
  >
    <path d="M12 19v3" />
    <path d="M15 9.34V5a3 3 0 0 0-5.68-1.33" />
    <path d="M16.95 16.95A7 7 0 0 1 5 12v-2" />
    <path d="M18.89 13.23A7 7 0 0 0 19 12v-2" />
    <path d="m2 2 20 20" />
    <path d="M9 9v3a3 3 0 0 0 5.12 2.12" />
  </svg>`;
};
export const waveIcon = (size: number) => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width=${size}
    height=${size}
    viewBox="0 0 16 17"
    fill="none"
  >
    <g clip-path="url(#clip0_3_10678)">
      <path
        d="M8 6.16675V10.8334"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M11 4.16675V12.8334"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M2 6.16675V10.8334"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M14 6.5V10.5"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M5 1.83337V15.1667"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3_10678">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>`;
};
export const sendIcon = (size = 20) => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    style="width: ${size}px; height: ${size}px; fill: white"
  >
    <path
      fill="currentColor"
      height=${size}
      width=${size}
      d="M568.4 37.7C578.2 34.2 589 36.7 596.4 44C603.8 51.3 606.2 62.2 602.7 72L424.7 568.9C419.7 582.8 406.6 592 391.9 592C377.7 592 364.9 583.4 359.6 570.3L295.4 412.3C290.9 401.3 292.9 388.7 300.6 379.7L395.1 267.3C400.2 261.2 399.8 252.3 394.2 246.7C388.6 241.1 379.6 240.7 373.6 245.8L261.2 340.1C252.1 347.7 239.6 349.7 228.6 345.3L70.1 280.8C57 275.5 48.4 262.7 48.4 248.5C48.4 233.8 57.6 220.7 71.5 215.7L568.4 37.7z"
    />
  </svg>`;
};
export const muteIcon = (size: number) => {
  return html`<svg
    width=${size}
    height=${size}
    viewBox="0 0 12 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 10.9062C4.4375 10.9062 3.39062 9.74219 3.39062 8.07812V2.85156C3.39062 1.17969 4.4375 0.0234375 6 0.0234375C7.55469 0.0234375 8.60156 1.17969 8.60156 2.85156V8.07812C8.60156 9.74219 7.55469 10.9062 6 10.9062ZM0.40625 8.20312V6.61719C0.40625 6.28906 0.664062 6.03125 0.992188 6.03125C1.32812 6.03125 1.58594 6.28906 1.58594 6.61719V8.15625C1.58594 10.8203 3.32031 12.5859 6 12.5859C8.67188 12.5859 10.4062 10.8203 10.4062 8.15625V6.61719C10.4062 6.28906 10.6719 6.03125 11 6.03125C11.3281 6.03125 11.5859 6.28906 11.5859 6.61719V8.20312C11.5859 11.2656 9.57031 13.4141 6.58594 13.6641V15.4844H9.48438C9.8125 15.4844 10.0781 15.75 10.0781 16.0781C10.0781 16.4062 9.8125 16.6641 9.48438 16.6641H2.50781C2.17969 16.6641 1.91406 16.4062 1.91406 16.0781C1.91406 15.75 2.17969 15.4844 2.50781 15.4844H5.40625V13.6641C2.42969 13.4141 0.40625 11.2656 0.40625 8.20312Z"
      fill="currentColor"
    />
  </svg>`;
};
export const speakerIcon = (size: number) => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    style="width: ${size}px; height: ${size}px; color: white"
  >
    <path fill="white" height=${size} width=${size} />
    <path
      fill="white"
      d="M533.6 96.5C523.3 88.1 508.2 89.7 499.8 100C491.4 110.3 493 125.4 503.3 133.8C557.5 177.8 592 244.8 592 320C592 395.2 557.5 462.2 503.3 506.3C493 514.7 491.5 529.8 499.8 540.1C508.1 550.4 523.3 551.9 533.6 543.6C598.5 490.7 640 410.2 640 320C640 229.8 598.5 149.2 533.6 96.5zM473.1 171C462.8 162.6 447.7 164.2 439.3 174.5C430.9 184.8 432.5 199.9 442.8 208.3C475.3 234.7 496 274.9 496 320C496 365.1 475.3 405.3 442.8 431.8C432.5 440.2 431 455.3 439.3 465.6C447.6 475.9 462.8 477.4 473.1 469.1C516.3 433.9 544 380.2 544 320.1C544 260 516.3 206.3 473.1 171.1zM412.6 245.5C402.3 237.1 387.2 238.7 378.8 249C370.4 259.3 372 274.4 382.3 282.8C393.1 291.6 400 305 400 320C400 335 393.1 348.4 382.3 357.3C372 365.7 370.5 380.8 378.8 391.1C387.1 401.4 402.3 402.9 412.6 394.6C434.1 376.9 448 350.1 448 320C448 289.9 434.1 263.1 412.6 245.5zM80 416L128 416L262.1 535.2C268.5 540.9 276.7 544 285.2 544C304.4 544 320 528.4 320 509.2L320 130.8C320 111.6 304.4 96 285.2 96C276.7 96 268.5 99.1 262.1 104.8L128 224L80 224C53.5 224 32 245.5 32 272L32 368C32 394.5 53.5 416 80 416z"
    />
  </svg>`;
};
export const endIcon = (size: number) => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    style="width: ${size}px; height: ${size}px; color: white"
  >
    <path
      fill="white"
      height=${size}
      width=${size}
      d="M567 39.1C576.4 29.7 591.6 29.7 600.9 39.1C610.2 48.5 610.3 63.7 600.9 73L73 601.1C63.6 610.5 48.4 610.5 39.1 601.1C29.8 591.7 29.7 576.5 39.1 567.2L173.5 432.6C121.2 374.5 83.6 302.8 66.8 223.4C50.7 147.1 105.9 84.6 170.5 66.9L176 65.4C195.7 60 216.3 70.1 224.1 88.9L264.6 186.2C271.5 202.7 266.7 221.8 252.8 233.2L208.7 269.3C221.6 297.8 238.3 324.1 258.2 347.8L567 39.1zM416.6 573.1C353.6 559.7 295.3 533.3 244.9 496.8L329.8 412C342 420.2 354.8 427.6 368.1 434.2L406.7 387C418 373.1 437.1 368.4 453.7 375.2L551 415.8C569.8 423.6 579.9 444.2 574.5 463.9L573 469.4C555.4 534 492.8 589.2 416.6 573.1z"
    />
  </svg>`;
};
export const xIcon = (size: number, color = "#000000") => {
  return html`<svg
    width=${size}
    height=${size}
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.2082 10.7917L10.7915 26.2084"
      stroke="${color}"
      stroke-width="1.81413"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.7915 10.7917L26.2082 26.2084"
      stroke="${color}"
      stroke-width="1.81413"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;
};
export const sparklesIcon = (size: number, color = "#6C7E85") => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width=${size}
    height=${size}
    viewBox="0 0 24 24"
    fill="currentColor"
    style="color: ${color}"
  >
    <path
      fill-rule="evenodd"
      d="M9 4.5a.75.75 0 0 1 .721.544l.813 2.846a3.75 3.75 0 0 0 2.576 2.576l2.846.813a.75.75 0 0 1 0 1.442l-2.846.813a3.75 3.75 0 0 0-2.576 2.576l-.813 2.846a.75.75 0 0 1-1.442 0l-.813-2.846a3.75 3.75 0 0 0-2.576-2.576l-2.846-.813a.75.75 0 0 1 0-1.442l2.846-.813A3.75 3.75 0 0 0 7.466 7.89l.813-2.846A.75.75 0 0 1 9 4.5m9-3a.75.75 0 0 1 .728.568l.258 1.036a2.63 2.63 0 0 0 1.91 1.91l1.036.258a.75.75 0 0 1 0 1.456l-1.036.258a2.63 2.63 0 0 0-1.91 1.91l-.258 1.036a.75.75 0 0 1-1.456 0l-.258-1.036a2.63 2.63 0 0 0-1.91-1.91l-1.036-.258a.75.75 0 0 1 0-1.456l1.036-.258a2.63 2.63 0 0 0 1.91-1.91l.258-1.036A.75.75 0 0 1 18 1.5M16.5 15a.75.75 0 0 1 .712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 0 1 0 1.422l-1.183.395a1.5 1.5 0 0 0-.948.948l-.395 1.183a.75.75 0 0 1-1.422 0l-.395-1.183a1.5 1.5 0 0 0-.948-.948l-1.183-.395a.75.75 0 0 1 0-1.422l1.183-.395a1.5 1.5 0 0 0 .948-.948l.395-1.183A.75.75 0 0 1 16.5 15"
      clip-rule="evenodd"
    />
  </svg>`;
};

// The following private icon functions had TypeScript errors due to their use outside a class and improper export usage. Fix by converting them to exported arrow functions.

export const phoneIconSvg = () => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path
      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
    />
  </svg>`;
};

export const sendIconSvg = () => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <line x1="22" y1="2" x2="11" y2="13"></line>
    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
  </svg>`;
};

export const sendMinimalSvg = (
  size: number = 20,
  color: string = "#456288"
) => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width=${size}
    height=${size}
    viewBox="0 0 24 24"
    fill="currentColor"
    style="color: ${color}"
  >
    <path fill="currentColor" d="M24.003 12L.292 1.665L3.587 11H11v2H3.587L.292 22.336z" />
  </svg>`;
};

/**
 * Microphone icon from public/microphone.svg
 * Supports size and color customization
 */
export const micIconSvg = (
  size: number = 24,
  color: string = "#456288",
  opacity: number = 0.5
) => {
  return html`<svg
    width=${size}
    height=${size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.75 6C15.75 3.92893 14.0711 2.25 12 2.25C9.92893 2.25 8.25 3.92893 8.25 6V12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12V6Z"
      stroke=${color}
      stroke-opacity=${opacity}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 18.75V22.5"
      stroke=${color}
      stroke-opacity=${opacity}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.75 12C18.75 13.7902 18.0388 15.5071 16.773 16.773C15.5071 18.0388 13.7902 18.75 12 18.75C10.2098 18.75 8.4929 18.0388 7.22703 16.773C5.96116 15.5071 5.25 13.7902 5.25 12"
      stroke=${color}
      stroke-opacity=${opacity}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;
};

/**
 * Microphone icon with size and color support (for backward compatibility)
 * Uses the new microphone.svg design
 */
export const micIcon = (size: number, color: string = "#456288") => {
  return micIconSvg(size, color, 0.5);
};

export const waveIconSvg = () => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <g clip-path="url(#clip0_3_10678)">
      <path
        d="M8 6.16675V10.8334"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M11 4.16675V12.8334"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M2 6.16675V10.8334"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M14 6.5V10.5"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M5 1.83337V15.1667"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3_10678">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>`;
};

export const figmaVolumeMaxSvg = (size: number) => {
  return html`<svg
    width=${size}
    height=${size}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 8.95054C2 8.48383 2 8.25048 2.09083 8.07222C2.17072 7.91541 2.29821 7.78793 2.45501 7.70804C2.63327 7.61721 2.86662 7.61721 3.33333 7.61721H4.78105C4.98487 7.61721 5.08679 7.61721 5.18269 7.59418C5.26772 7.57377 5.34901 7.5401 5.42357 7.49441C5.50767 7.44287 5.57973 7.37081 5.72386 7.22668L8.36193 4.58861C8.71891 4.23163 8.8974 4.05314 9.05064 4.04108C9.18361 4.03062 9.31355 4.08444 9.40017 4.18586C9.5 4.30275 9.5 4.55517 9.5 5.06002V16.8411C9.5 17.3459 9.5 17.5983 9.40017 17.7152C9.31355 17.8166 9.18361 17.8705 9.05064 17.86C8.8974 17.8479 8.71891 17.6695 8.36193 17.3125L5.72386 14.6744C5.57973 14.5303 5.50767 14.4582 5.42357 14.4067C5.34901 14.361 5.26772 14.3273 5.18269 14.3069C5.08679 14.2839 4.98487 14.2839 4.78105 14.2839H3.33333C2.86662 14.2839 2.63327 14.2839 2.45501 14.193C2.29821 14.1132 2.17072 13.9857 2.09083 13.8289C2 13.6506 2 13.4173 2 12.9505V8.95054Z"
      stroke="#6C7E85"
      stroke-width="1.5"
      width=${size}
      height=${size}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.5597 6.94995C17.4662 8.0758 18 9.45717 18 10.95C18 12.4427 17.4662 13.8241 16.5597 14.95M14 8.66424C14.5058 9.31214 14.8024 10.1001 14.8024 10.95C14.8024 11.7998 14.5058 12.5878 14 13.2357"
      stroke="#6C7E85"
      stroke-width="1.5"
      width=${size}
      height=${size}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;
};

export const videoSvg = (size: number) => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width=${size}
    height=${size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="#6C7E85"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path
      d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"
    />
    <rect x="2" y="6" width="14" height="12" rx="2" />
  </svg>`;
};

export const figmaCopySvg = (size: number) => {
  return html`<svg
    width=${size}
    height=${size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8 10.75V12.71C10.8 13.494 10.8 13.8861 10.6474 14.1855C10.5132 14.449 10.299 14.6631 10.0356 14.7974C9.73611 14.95 9.34407 14.95 8.56 14.95H3.24C2.45593 14.95 2.06389 14.95 1.76441 14.7974C1.50099 14.6631 1.28681 14.449 1.15259 14.1855C1 13.8861 1 13.494 1 12.71V7.38995C1 6.60588 1 6.21384 1.15259 5.91436C1.28681 5.65094 1.50099 5.43676 1.76441 5.30254C2.06389 5.14995 2.45593 5.14995 3.24 5.14995H5.2M7.44 10.75H12.76C13.5441 10.75 13.9361 10.75 14.2356 10.5974C14.499 10.4631 14.7132 10.249 14.8474 9.98554C15 9.68606 15 9.29402 15 8.50995V3.18995C15 2.40588 15 2.01384 14.8474 1.71436C14.7132 1.45094 14.499 1.23676 14.2356 1.10254C13.9361 0.949951 13.5441 0.949951 12.76 0.949951H7.44C6.65593 0.949951 6.26389 0.949951 5.96441 1.10254C5.70099 1.23676 5.48681 1.45094 5.35259 1.71436C5.2 2.01384 5.2 2.40588 5.2 3.18995V8.50995C5.2 9.29402 5.2 9.68606 5.35259 9.98554C5.48681 10.249 5.70099 10.4631 5.96441 10.5974C6.26389 10.75 6.65593 10.75 7.44 10.75Z"
      stroke="#6C7E85"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;
};

export const checkIconSvg = (size: number) => {
  return html`<svg
    width=${size}
    height=${size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9 16.2l-3.5-3.5-1.4 1.4L9 19 20.3 7.7l-1.4-1.4z" fill="#6C7E85" />
  </svg>`;
};

export const stopIconSvg = (size: number) => {
  return html`<svg
    width=${size}
    height=${size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="6" y="6" width="12" height="12" rx="2" fill="#6C7E85" />
  </svg>`;
};

export const pauseIconSvg = (size: number) => {
  return html`<svg
    width=${size}
    height=${size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="6" y="5" width="4" height="14" rx="1" fill="#6C7E85" />
    <rect x="14" y="5" width="4" height="14" rx="1" fill="#6C7E85" />
  </svg>`;
};

export const playIconSvg = (size: number) => {
  return html`<svg
    width=${size}
    height=${size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 5V19L19 12L7 5Z" fill="#6C7E85" />
  </svg>`;
};

export const deleteIconSvg = () => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#ef4444"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
    <path d="M3 6h18" />
    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  </svg>`;
};

export const recordingDotSvg = () => {
  return html`<svg fill="none" preserveAspectRatio="none" viewBox="0 0 10 10">
    <g id="Ellipse 17882">
      <circle cx="5" cy="5" r="5" fill="#D20446" />
    </g>
  </svg>`;
};

export const sendUpIconSvg = () => {
  return html`<svg fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
    <g id="up-2">
      <path
        d="M12 5V19"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        d="M18 11L12 5"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        d="M6 11L12 5"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </g>
  </svg>`;
};

export const talkingIconSvg = (width: number, height?: number) => {
  return html`<svg
    width=${width}
    height=${height}
    style="cursor: pointer;"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0722 17.4898C14.2565 17.3269 14.4276 17.1914 14.5796 17.0381C14.9103 16.7034 14.9302 16.4834 14.7576 16.0448C14.616 15.6852 14.473 15.3181 14.4036 14.9407C14.3018 14.3921 14.5493 14.0319 15.0856 13.8827C15.4485 13.7817 15.8239 13.7287 16.1903 13.638C16.9218 13.4579 17.1679 13.0805 16.8867 12.3745C16.6179 11.6994 16.2281 11.0724 15.8961 10.4228C15.298 9.25272 14.6903 8.08679 14.1107 6.90712C13.6226 5.91306 13.6934 4.95888 14.4105 4.08237C14.7686 3.64446 14.8889 3.14399 14.7446 2.60022C14.4545 1.50716 14.1444 0.420298 13.8481 -0.67138C13.7814 -0.916801 13.6542 -1.00136 13.3868 -0.999984C10.6039 -0.988297 7.82034 -0.997234 5.03745 -0.990359C1.68602 -0.98211 -0.992376 1.72784 -0.990314 5.07849C-0.985502 13.1767 -0.975878 21.2742 -0.999939 29.3725C-1.00475 30.935 -0.728388 32.3773 0.24645 33.6271C1.37872 35.0783 2.86778 35.8717 4.71159 35.9975C4.9907 36.0167 5.05464 35.9287 5.05945 35.6565C5.09795 33.5859 5.13576 31.5153 5.21619 29.446C5.24026 28.8335 5.39012 28.2251 5.50081 27.6181C5.72974 26.3648 6.62414 25.7592 7.74953 25.4883C8.44182 25.3213 9.17742 25.335 9.89307 25.2649C10.5757 25.1975 11.2605 25.1419 11.9411 25.0532C13.4886 24.8504 14.4187 23.4741 14.0997 21.8923C14.0028 21.411 13.8653 20.9381 13.7532 20.4589C13.6288 19.9248 13.7086 19.4442 14.1994 19.1253C14.7982 18.7362 14.7233 18.3938 14.3307 17.7957C14.2627 17.6919 14.1698 17.6046 14.0722 17.4898Z"
      fill="#6C7E85"
    />
    <path
      d="M19 14C19.621 14.4657 20.125 15.0697 20.4721 15.7639C20.8193 16.4582 21 17.2238 21 18C21 18.7762 20.8193 19.5418 20.4721 20.2361C20.125 20.9303 19.621 21.5343 19 22"
      stroke="#6C7E85"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.7 11C22.7439 11.8437 23.586 12.9101 24.1644 14.1213C24.7429 15.3325 25.0431 16.6578 25.0431 18C25.0431 19.3422 24.7429 20.6675 24.1644 21.8787C23.586 23.0899 22.7439 24.1563 21.7 25"
      stroke="#6C7E85"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;
};

export const lipsIconSvg = (width: number, height?: number) => {
  return html`<svg
    width=${width}
    height=${height}
    style="cursor: pointer;"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_155_620)">
      <rect width="32" height="32" rx="16" fill="#3784FF" />
      <path
        d="M14.0722 17.4898C14.2565 17.3269 14.4276 17.1914 14.5796 17.0381C14.9103 16.7034 14.9302 16.4834 14.7576 16.0448C14.616 15.6852 14.473 15.3181 14.4036 14.9407C14.3018 14.3921 14.5493 14.0319 15.0856 13.8827C15.4485 13.7817 15.8239 13.7287 16.1903 13.638C16.9218 13.4579 17.1679 13.0805 16.8867 12.3745C16.6179 11.6994 16.2281 11.0724 15.8961 10.4228C15.298 9.25272 14.6903 8.08679 14.1107 6.90712C13.6226 5.91306 13.6934 4.95888 14.4105 4.08237C14.7686 3.64446 14.8889 3.14399 14.7446 2.60022C14.4545 1.50716 14.1444 0.420298 13.8481 -0.67138C13.7814 -0.916801 13.6542 -1.00136 13.3868 -0.999984C10.6039 -0.988297 7.82034 -0.997234 5.03745 -0.990359C1.68602 -0.98211 -0.992376 1.72784 -0.990314 5.07849C-0.985502 13.1767 -0.975878 21.2742 -0.999939 29.3725C-1.00475 30.935 -0.728388 32.3773 0.24645 33.6271C1.37872 35.0783 2.86778 35.8717 4.71159 35.9975C4.9907 36.0167 5.05464 35.9287 5.05945 35.6565C5.09795 33.5859 5.13576 31.5153 5.21619 29.446C5.24026 28.8335 5.39012 28.2251 5.50081 27.6181C5.72974 26.3648 6.62414 25.7592 7.74953 25.4883C8.44182 25.3213 9.17742 25.335 9.89307 25.2649C10.5757 25.1975 11.2605 25.1419 11.9411 25.0532C13.4886 24.8504 14.4187 23.4741 14.0997 21.8923C14.0028 21.411 13.8653 20.9381 13.7532 20.4589C13.6288 19.9248 13.7086 19.4442 14.1994 19.1253C14.7982 18.7362 14.7233 18.3938 14.3307 17.7957C14.2627 17.6919 14.1698 17.6046 14.0722 17.4898Z"
        fill="white"
      />
    </g>
    <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#1DA4E0" />
    <defs>
      <clipPath id="clip0_155_620">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>`;
};

export const lipsDefaultIconSvg = (width: number, height?: number) => {
  return html`<svg
    width=${width}
    height=${height}
    style="cursor: pointer;"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_90_5562)">
      <rect width="32" height="32" rx="16" fill="#81CDFD" />
      <path
        d="M14.0722 17.4898C14.2565 17.3269 14.4276 17.1914 14.5796 17.0381C14.9103 16.7034 14.9302 16.4834 14.7576 16.0448C14.616 15.6852 14.473 15.3181 14.4036 14.9407C14.3018 14.3921 14.5493 14.0319 15.0856 13.8827C15.4485 13.7817 15.8239 13.7287 16.1903 13.638C16.9218 13.4579 17.1679 13.0805 16.8867 12.3745C16.6179 11.6994 16.2281 11.0724 15.8961 10.4228C15.298 9.25272 14.6903 8.08679 14.1107 6.90712C13.6226 5.91306 13.6934 4.95888 14.4105 4.08237C14.7686 3.64446 14.8889 3.14399 14.7446 2.60022C14.4545 1.50716 14.1444 0.420298 13.8481 -0.67138C13.7814 -0.916801 13.6542 -1.00136 13.3868 -0.999984C10.6039 -0.988297 7.82034 -0.997234 5.03745 -0.990359C1.68602 -0.98211 -0.992376 1.72784 -0.990314 5.07849C-0.985502 13.1767 -0.975878 21.2742 -0.999939 29.3725C-1.00475 30.935 -0.728388 32.3773 0.24645 33.6271C1.37872 35.0783 2.86778 35.8717 4.71159 35.9975C4.9907 36.0167 5.05464 35.9287 5.05945 35.6565C5.09795 33.5859 5.13576 31.5153 5.21619 29.446C5.24026 28.8335 5.39012 28.2251 5.50081 27.6181C5.72974 26.3648 6.62414 25.7592 7.74953 25.4883C8.44182 25.3213 9.17742 25.335 9.89307 25.2649C10.5757 25.1975 11.2605 25.1419 11.9411 25.0532C13.4886 24.8504 14.4187 23.4741 14.0997 21.8923C14.0028 21.411 13.8653 20.9381 13.7532 20.4589C13.6288 19.9248 13.7086 19.4442 14.1994 19.1253C14.7982 18.7362 14.7233 18.3938 14.3307 17.7957C14.2627 17.6919 14.1698 17.6046 14.0722 17.4898Z"
        fill="white"
      />
      <path
        d="M19 14C19.621 14.4657 20.125 15.0697 20.4721 15.7639C20.8193 16.4582 21 17.2238 21 18C21 18.7762 20.8193 19.5418 20.4721 20.2361C20.125 20.9303 19.621 21.5343 19 22"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.7002 11C22.7442 11.8437 23.5862 12.9101 24.1647 14.1213C24.7431 15.3325 25.0433 16.6578 25.0433 18C25.0433 19.3422 24.7431 20.6675 24.1647 21.8787C23.5862 23.0899 22.7442 24.1563 21.7002 25"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#81CDFD" />
    <defs>
      <clipPath id="clip0_90_5562">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>`;
};

export const shutIconSvg = (width: number, height?: number) => {
  return html`<svg
    width=${width}
    height=${height}
    style="cursor: pointer;"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_204_1251)">
      <rect width="32" height="32" rx="16" fill="black" />
      <path
        d="M14.0722 17.4898C14.2565 17.3269 14.4276 17.1914 14.5796 17.0381C14.9103 16.7034 14.9302 16.4834 14.7576 16.0448C14.616 15.6852 14.473 15.3181 14.4036 14.9407C14.3018 14.3921 14.5493 14.0319 15.0856 13.8827C15.4485 13.7817 15.8239 13.7287 16.1903 13.638C16.9218 13.4579 17.1679 13.0805 16.8867 12.3745C16.6179 11.6994 16.2281 11.0724 15.8961 10.4228C15.298 9.25272 14.6903 8.08679 14.1107 6.90712C13.6226 5.91306 13.6934 4.95888 14.4105 4.08237C14.7686 3.64446 14.8889 3.14399 14.7446 2.60022C14.4545 1.50716 14.1444 0.420298 13.8481 -0.67138C13.7814 -0.916801 13.6542 -1.00136 13.3868 -0.999984C10.6039 -0.988297 7.82034 -0.997234 5.03745 -0.990359C1.68602 -0.98211 -0.992376 1.72784 -0.990314 5.07849C-0.985502 13.1767 -0.975878 21.2742 -0.999939 29.3725C-1.00475 30.935 -0.728388 32.3773 0.24645 33.6271C1.37872 35.0783 2.86778 35.8717 4.71159 35.9975C4.9907 36.0167 5.05464 35.9287 5.05945 35.6565C5.09795 33.5859 5.13576 31.5153 5.21619 29.446C5.24026 28.8335 5.39012 28.2251 5.50081 27.6181C5.72974 26.3648 6.62414 25.7592 7.74953 25.4883C8.44182 25.3213 9.17742 25.335 9.89307 25.2649C10.5757 25.1975 11.2605 25.1419 11.9411 25.0532C13.4886 24.8504 14.4187 23.4741 14.0997 21.8923C14.0028 21.411 13.8653 20.9381 13.7532 20.4589C13.6288 19.9248 13.7086 19.4442 14.1994 19.1253C14.7982 18.7362 14.7233 18.3938 14.3307 17.7957C14.2627 17.6919 14.1698 17.6046 14.0722 17.4898Z"
        fill="white"
      />
      <path
        d="M25.75 15.25L18.25 22.75"
        stroke="white"
        stroke-width="1.81413"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.25 15.25L25.75 22.75"
        stroke="white"
        stroke-width="1.81413"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="black" />
    <defs>
      <clipPath id="clip0_204_1251">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>`;
};

export const hamburgerIconSvg = () => {
  return html`<svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 12H21"
      stroke="#6C7E85"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3 6H21"
      stroke="#6C7E85"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3 18H21"
      stroke="#6C7E85"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;
};

export const plusIconSvg = (size: number = 24, color: string = "#000000") => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width=${size}
    height=${size}
    viewBox="0 0 24 24"
    fill="none"
    stroke=${color}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M8 12h8" />
    <path d="M12 8v8" />
  </svg>`;
};

export const penIconSvg = (size: number = 24, color: string = "#000000") => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${size}
    height=${size}
    color="currentColor"
    fill="none"
    stroke=${color}
    stroke-width="1.5"
    stroke-linejoin="round"
  >
    <path d="M16.4249 4.60509L17.4149 3.6151C18.2351 2.79497 19.5648 2.79497 20.3849 3.6151C21.205 4.43524 21.205 5.76493 20.3849 6.58507L19.3949 7.57506M16.4249 4.60509L9.76558 11.2644C9.25807 11.772 8.89804 12.4078 8.72397 13.1041L8 16L10.8959 15.276C11.5922 15.102 12.228 14.7419 12.7356 14.2344L19.3949 7.57506M16.4249 4.60509L19.3949 7.57506" />
    <path d="M18.9999 13.5C18.9999 16.7875 18.9999 18.4312 18.092 19.5376C17.9258 19.7401 17.7401 19.9258 17.5375 20.092C16.4312 21 14.7874 21 11.4999 21H11C7.22876 21 5.34316 21 4.17159 19.8284C3.00003 18.6569 3 16.7712 3 13V12.5C3 9.21252 3 7.56879 3.90794 6.46244C4.07417 6.2599 4.2599 6.07417 4.46244 5.90794C5.56879 5 7.21252 5 10.5 5" />
  </svg>`;
};

export const errorIcon = (size: number = 20) => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width=${size}
    height=${size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    style="color: #ef4444"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>`;
};

export const warningIcon = (size: number = 20) => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width=${size}
    height=${size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    style="color: #f59e0b"
  >
    <path
      d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
    />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>`;
};

export const successIcon = (size: number = 20) => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width=${size}
    height=${size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    style="color: #10b981"
  >
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>`;
};

export const chevronDownIcon = (size: number = 16, color: string = "#6B7280") => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width=${size}
    height=${size}
    viewBox="0 0 24 24"
    fill="none"
    stroke=${color}
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    style="color: ${color}"
  >
    <polyline points="6 9 12 15 18 9"></polyline>
  </svg>`;
};
